<div class="unauthorized-page">
  <h1>Access Denied</h1>
  <p>You do not have permission to access this page.</p>
  <a routerLink="/dashboard">← Back to Dashboard</a>
</div>
